import React from 'react';
import Link from '../Link';

import './index.scss';

const Button = ({ url, label, describedBy, isPrimary = true, customVariant, fileDownload = null }) => {
  return (
    <Link
      className={`egp-btn ${isPrimary ? 'primary' : 'secondary'} ${customVariant}`}
      to={fileDownload?.url ? fileDownload.url : url}
      aria-describedby={describedBy}
    >
      {label}
    </Link>
  );
};

export default Button;
